// Bootstrap pattern for Module Federation
import('./bootstrap');
